import {ReviewStatusType} from './reviews-statuses';
import {SYSTEM_DEFAULT_REVIEW_STATUS_CODES} from './reviews-statuses-const';

export function getVisibleReviewStatuses(
    statuses: Array<ReviewStatusType>,
    hiddenStatusCodes: Set<string>
): Array<ReviewStatusType> {
    if (hiddenStatusCodes.size === 0) {
        return statuses;
    }

    return statuses.filter((status) => !hiddenStatusCodes.has(status.statusCode));
}

export function isSystemDefaultStatus(reviewStatus: ReviewStatusType): boolean {
    if (!reviewStatus.isDefault) {
        return false;
    }

    if (reviewStatus.canDelete === true) {
        return false;
    }

    if (reviewStatus.canDelete === false) {
        return true;
    }

    return SYSTEM_DEFAULT_REVIEW_STATUS_CODES.has(reviewStatus.statusCode);
}

export function isDefaultStatusDeletable(reviewStatus: ReviewStatusType): boolean {
    if (!reviewStatus.isDefault) {
        return false;
    }

    if (reviewStatus.canDelete === true) {
        return true;
    }

    if (reviewStatus.canDelete === false) {
        return false;
    }

    return !SYSTEM_DEFAULT_REVIEW_STATUS_CODES.has(reviewStatus.statusCode);
}

export function isCustomStatusDeletable(reviewStatus: ReviewStatusType): boolean {
    return !reviewStatus.isDefault;
}
